import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-combo',
  templateUrl: './combo.component.html',
  styleUrls: ['./combo.component.css']
})
export class ComboComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  columnNames = [{
    id: 'sno',
    value: 'S.No.',

  }, {
    id: 'service_category',
    value: 'Service Category',
  },
  {
    id: 'actions',
    value: 'Action',
  }
  ];



  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  p: number = 1;
  dataresult: any = [];
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;
  recordsperpage: number = 25;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('11');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
    this.model.status = "";
    this.model.service_category = "";
    this.model.end_date = "";
    this.model.start_date = "";
    // this.displayedColumns = this.columnNames.map(x => x.id);


    this.getserviceoffered('');

    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  reset() {
    this.ngOnInit();
  }

  search() {
    this.getserviceoffered('');
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addvendor() {
    this.router.navigate(['add-combo']);
  }

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  getserviceoffered(service_offered_id) {
    this.loginservice.getserviceoffered(service_offered_id, '2', '', '', this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];

            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getserviceoffered API');
          // alert('Error in get contractor details');
          this.showLoader = false;
        });

  }


  // Angular component code
  handleClick(columnId: string, element: any) {
    switch (columnId) {
      // case 'edit':
      //   this.edit(element.vendor_id);
      //   break;
      // case 'view':
      //   this.view(element.vendor_id);
      //   break;
      case 'delete':
        this.delete(element.vendor_id);
        break;
      default:
        break;
    }
  }

  delete(service_category_id: number) {
    // Handle delete action
    // alert('delete');
    // alert(service_category_id);
    if (confirm('Deleting of this Service Offered is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridDataNew(service_category_id, 'service_category_id', 'service_offered', 'status', '2').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Network Error combo delete API');
            this.showLoader = false;
          });
      }
    }
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/combo/combo.component.ts